import { render } from "./single-dynamic.vue?vue&type=template&id=6f2e65a7&lang=pug"
import script from "./single-dynamic.vue?vue&type=script&setup=true&lang=js"
export * from "./single-dynamic.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__